import { ContentCatalog } from '../features/catalogs/content-catalog.js';

export class ModelArrangement {

    $editable = false;
	$saveable = false;

    refresh() {
        this.$editable = this.$access && this.$access > 1 || false;
	    this.$saveable = $User.logged && this.$editable || false;
    }

    setCatalogs( catalogs = [] ) {

        if (!Array.isArray( catalogs )) {
            console.error( new Error( "Invalid type of arrangement.catalogs!" ));
            catalogs = [];
            debugger;
        }
    
        this.catalogs = catalogs.map( catalog => {
            return ContentCatalog.fromJSON( catalog );
        });
    }

    static fromJSON( json ) {

        try {

            var arrangement = angular.extend( new ModelArrangement(), json );

            arrangement.setCatalogs( arrangement.catalogs );

            arrangement.refresh();

            return arrangement;

        } catch( error ) {
            console.error( "ModelArrangement.fromJSON :: ", error );
        }
    }
}